import React from 'react';
import classnames from 'classnames';
import { Card } from '@guildeducationinc/recess';
import './ActionCard.scss';

export interface ActionCardIcon {
  alt: string;
  src: string;
}

export interface ActionCardProps {
  testid?: string;
  badge?: React.ReactElement;
  icon: ActionCardIcon;
  iconAlign?: 'top' | 'right' | 'logo';
  background?: boolean;
  className?: string;
}

const ActionCard: React.FC<ActionCardProps> = ({
  testid,
  children,
  badge,
  background = false,
  className,
}) => {
  /*
  The Action Required Badge currently uses the default recess padding and applies a negative
  margin to it. If the padding of this component changes or becomes responsive, an update must
  also be made to the Action Required Badge
  */
  const actionCardClassNames = classnames(
    'actionCard',
    className,
    background && 'actionCard-color'
  );

  const cardContentClassNames = classnames(
    'flex',
    'flexJustify--space_between',
    'flexContent--center',
    'flex--1',
    'flexBasis--auto'
  );

  const childrenContainerClassNames = classnames('flex', 'flex--1', 'flexDirection--column');

  return (
    <Card data-testid={testid} className={actionCardClassNames}>
      <div className='badgeSpacing'>{badge}</div>
      <Card.Content className={cardContentClassNames}>
        <div className={childrenContainerClassNames}>{children}</div>
      </Card.Content>
    </Card>
  );
};

export default ActionCard;
